<div class="d-flex align-items-center flex-column">
    <div class="pallet-img-container">
        <img class="pallet-img" [src]="getPalletImage()" />

        <div class="pallet-overlay" [ngClass]="getOverlayHeight()"></div>
    </div>

    <div class="pallet-dimension-container">
        <div>dimension: {{dimension.width }}x{{dimension.depth}}x{{dimension.height}}</div>
        <div>weight: {{dimension.weight}}kg</div>
        <div>fill approximately: {{pallet.usedSpace | number : '1.2-2'}}%</div>
    </div>
</div>

